import { lazy, Suspense, StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { isDemo, useTransport } from './lib/api';
import { startAnalytics } from './lib/analytics';
import { demoTransport } from './lib/mock';
import * as telegram from './lib/telegram';
import { StoreProvider } from './state/store';
import './styles.css';

// Вне Telegram и без адреса API поднимаем демо-бэкенд: приложение открывается
// в обычном браузере с пустым списком проектов и проходимым флоу.
const isAdmin = window.location.pathname.replace(/\/$/, '') === '/admin';
const Admin = lazy(() => import('./admin/Admin').then((m) => ({ default: m.Admin })));
const hasApiUrl = typeof import.meta.env['VITE_API_URL'] === 'string';
if (!isAdmin && !telegram.initDataRaw && !hasApiUrl) {
  useTransport(demoTransport, true);
}
if (!isAdmin) startAnalytics(isDemo());

const container = document.getElementById('root');
if (!container) throw new Error('Не найден контейнер #root');

createRoot(container).render(
  <StrictMode>
    {isAdmin ? (
      <Suspense fallback={<p>Загружаем аналитику…</p>}>
        <Admin />
      </Suspense>
    ) : (
      <StoreProvider>
        <App />
      </StoreProvider>
    )}
  </StrictMode>,
);
